import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.entries.js";
import React from 'react';
import JSZip from 'jszip';
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { ViewerControlButtonDownload, ViewerControlButtonTransparent, ViewerControlsBox } from "../../controls";
import { ViewArchiveInfoLoadingIcon } from "../../status";
import clsx from 'clsx';
import { ViewArchive } from "../../../view-archive.component";
import mime from 'mime';
import { getArchiveIcon } from "../../../tools";
import { blobToFile } from "../../../../utils";
import { Ripple } from '@isyc-react/animation/modules/base/transition';
import { ArchiveViewerProvider, ArchiveViewerView } from "../../context";
import "./view-zip.style.scss";

// TODO implement onViewed with the onViewed of all inner archives

export const ViewZip = props => {
  const {
    file,
    decompressedDelay = 2000,
    onViewed
  } = props;
  const [zip, setZip] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [innerFile, setInnerFile] = React.useState(null);
  const [loadingInnerFile, setLoadingInnerFile] = React.useState(false);
  React.useEffect(() => {
    onViewed && onViewed();
  }, []);
  React.useEffect(() => {
    const zip = new JSZip();
    zip.loadAsync(file).then(data => {
      setTimeout(() => {
        setLoading(false);
        setZip(data);
      }, decompressedDelay);
    }).catch(e => {
      setLoading(false);
      setError(true);
      console.error('[ZIP] Error parse', e);
    });
  }, [file]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-zip-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-zip-tools"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file
    },
    name: file.name
  }))), /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-zip-document"
  }, loading && /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: file.name
  }), zip && /*#__PURE__*/React.createElement(React.Fragment, null, innerFile ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "zip-inner-file-back my-1 btn-ripple",
    onClick: () => {
      setInnerFile(null);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-left font-size-24 mx-2 text-primary"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary"
  }, innerFile.name), /*#__PURE__*/React.createElement(Ripple, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ArchiveViewerProvider, {
    view: ArchiveViewerView.STATIC
  }, /*#__PURE__*/React.createElement(ViewArchive, {
    archive: {
      file: innerFile
    },
    name: innerFile.name
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column w-100"
  }, Object.entries(zip.files).map(([path, file], key) => /*#__PURE__*/React.createElement("div", {
    key: key,
    className: "p-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-3 zip-file-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: clsx(file.dir ? 'mdi mdi-folder text-grey' : getArchiveIcon(path).icon, 'font-size-26 me-2')
  }), /*#__PURE__*/React.createElement("h3", {
    className: "mb-0 text-secondary"
  }, path), !loadingInnerFile && !file.dir && /*#__PURE__*/React.createElement(ViewerControlButtonTransparent, {
    onClick: () => {
      setLoadingInnerFile(true);
      file.async('blob').then(blob => {
        var _mime$getType;
        setLoadingInnerFile(false);
        setInnerFile(blobToFile(blob, file.name, (_mime$getType = mime.getType(file.name)) !== null && _mime$getType !== void 0 ? _mime$getType : undefined));
      }).catch(e => {
        setLoadingInnerFile(false);
        console.error('[ZIP] Error reading compressed file', file.name, e); // TODO feedback?
      });
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-eye"
  }))), /*#__PURE__*/React.createElement("div", null, "Date: ", file.date.toDateString())))))))));
};